/* Olfa Originals, Gift Box Builder (prefix: ogb-) */
(function () {
  'use strict';

  function formatMoney(cents, format, hideZeros) {
    var re = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || '{{amount}}';
    var m = fmt.match(re);
    var key = m ? m[1] : 'amount';
    function delim(n, precision, thousands, decimal) {
      var parts = (n / 100).toFixed(precision).split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      if (hideZeros && parts[1] && /^0+$/.test(parts[1])) return parts[0];
      return parts[1] ? parts[0] + decimal + parts[1] : parts[0];
    }
    var v;
    switch (key) {
      case 'amount_no_decimals': v = delim(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = delim(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = delim(cents, 2, "'", '.'); break;
      default: v = delim(cents, 2, ',', '.');
    }
    return fmt.replace(re, v);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function sizedImg(u, w) {
    if (!u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function Builder(root) {
    this.root = root;
    this.d = root.dataset;
    this.size = parseInt(this.d.boxSize, 10) || 3;
    this.pct = parseFloat(this.d.percent) || 0;
    this.box = [];
    for (var i = 0; i < this.size; i++) this.box.push(null);
    this.lastAdded = -1;
    this.activePreset = -1;
    this.cards = Array.prototype.slice.call(root.querySelectorAll('[data-ogb-card]'));
    this.presets = Array.prototype.slice.call(root.querySelectorAll('[data-ogb-preset]'));
    this.q = function (sel) { return root.querySelector(sel); };
    this.bind();
    this.initQV();
    this.observe();
    this.render();
  }

  var P = Builder.prototype;

  P.money = function (c) { return formatMoney(c, this.d.moneyFormat, this.d.hideZeros === 'true'); };
  P.fill = function (tpl, left, total) {
    return String(tpl || '').replace(/\[left\]/g, left).replace(/\[total\]/g, total).replace(/\[percent\]/g, this.pct).replace(/\[n\]/g, left);
  };
  P.filled = function () { return this.box.filter(Boolean).length; };
  P.count = function (id) { return this.box.filter(function (b) { return b && b.productId === id; }).length; };
  P.say = function (t) { var m = this.q('[data-ogb-msg]'); if (m) m.textContent = t || ''; };

  P.itemFromCard = function (card) {
    var cd = card.dataset, desc = card.querySelector('.ogb-desc');
    return {
      productId: cd.id, variantId: cd.variantId, title: cd.title,
      sub: cd.variantTitle || '', desc: desc ? desc.textContent : '',
            price: parseInt(cd.price, 10) || 0, img: cd.img, eng: card.hasAttribute('data-engravable')
    };
  };

  P.add = function (card) {
    if (card.hasAttribute('data-soldout') || card.hasAttribute('data-unavailable')) return false;
    var i = this.box.indexOf(null);
    if (i < 0) return false;
    this.box[i] = this.itemFromCard(card);
    this.lastAdded = i;
    this.activePreset = -1;
    this.render();
    this.say(this.filled() === this.size ? this.d.msgFull : '');
    if (this.filled() === this.size) this.glow();
    return true;
  };

  P.removeOne = function (id) {
    for (var i = this.box.length - 1; i >= 0; i--) {
      if (this.box[i] && this.box[i].productId === id) { this.box[i] = null; break; }
    }
    this.lastAdded = -1; this.activePreset = -1; this.say(''); this.render();
  };

  P.removeAt = function (i) {
    this.box[i] = null; this.lastAdded = -1; this.activePreset = -1; this.say(''); this.render();
  };

  P.applyPreset = function (btn) {
    if (btn.disabled) return;
    var el = btn.querySelector('[data-ogb-preset-items]'), items = [];
    try { items = JSON.parse(el.textContent); } catch (e) { items = []; }
    if (items.length !== this.size) return;
        this.box = items.map(function (it) { it.productId = String(it.productId); it.eng = !!it.eng; return it; });
    this.lastAdded = 'all';
    this.activePreset = this.presets.indexOf(btn);
    this.render();
    this.glow();
    this.say(this.d.msgPreset);
    if (window.innerWidth < 1000) {
      var panel = this.q('[data-ogb-panel]');
      if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  P.glow = function () {
    var b = this.q('[data-ogb-box]');
    if (!b) return;
    b.classList.remove('is-full'); void b.offsetWidth; b.classList.add('is-full');
  };

  P.bind = function () {
    var self = this, root = this.root;

    root.addEventListener('click', function (e) {
      /* product image or name: open the details popup instead of the product page */
      var qvEl = e.target.closest('[data-ogb-qv]');
      if (qvEl && root.contains(qvEl)) {
        var qcard = qvEl.closest('[data-ogb-card]');
        if (qcard) { e.preventDefault(); self.openQV(qcard); return; }
      }
      if (e.target.closest('[data-ogb-qv-bg]')) { self.closeQV(true); return; }

      /* mobile pin bar: tap to jump back to the box */
      if (e.target.closest('[data-ogb-pin]')) {
        var panel = self.q('[data-ogb-panel]');
        if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      var t = e.target.closest('button');
      if (!t || !root.contains(t)) return;
      var card = t.closest('[data-ogb-card]');
      if (t.hasAttribute('data-ogb-plus') && card) self.add(card);
      else if (t.hasAttribute('data-ogb-minus') && card) self.removeOne(card.dataset.id);
      else if (t.hasAttribute('data-ogb-remove')) self.removeAt(parseInt(t.getAttribute('data-ogb-remove'), 10));
      else if (t.hasAttribute('data-ogb-var') && card) self.selectVariant(card, t);
      else if (t.hasAttribute('data-ogb-tab')) self.selectTab(t);
      else if (t.hasAttribute('data-ogb-preset')) self.applyPreset(t);
      else if (t.hasAttribute('data-ogb-cta')) self.onCta(t);
      else if (t.hasAttribute('data-ogb-qv-close')) self.closeQV(true);
      else if (t.hasAttribute('data-ogb-qv-add')) self.qvAdd();
      else if (t.hasAttribute('data-ogb-qv-dot')) self.qvGoTo(parseInt(t.getAttribute('data-ogb-qv-dot'), 10));
    });

    root.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-ogb-opt]');
      if (!sel) return;
      var card = sel.closest('[data-ogb-card]');
      if (card) self.selectOptions(card);
    });

    var tablist = this.q('[role="tablist"]');
    if (tablist) {
      tablist.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var tabs = Array.prototype.slice.call(tablist.querySelectorAll('[role="tab"]'));
        var i = tabs.indexOf(document.activeElement);
        if (i < 0) return;
        var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
        n.focus(); self.selectTab(n);
      });
    }

    var note = this.q('[data-ogb-notetext]');
    if (note) note.addEventListener('input', function () { self.q('[data-ogb-count]').textContent = note.value.length; });

    var iniTog = this.q('[data-ogb-initials-tog]'), ini = this.q('[data-ogb-initials]');
    if (iniTog) iniTog.addEventListener('change', function () {
      self.q('[data-ogb-initials-wrap]').classList.toggle('is-open', iniTog.checked);
      if (iniTog.checked && ini) ini.focus();
      if (!iniTog.checked && ini) ini.value = '';
    });
    if (ini) ini.addEventListener('input', function () {
      ini.value = ini.value.replace(/[^A-Za-z]/g, '').toUpperCase().slice(0, 2);
    });
  };

  /* Mobile pin bar: shows once the box has scrolled up out of view */
  P.observe = function () {
    var box = this.q('[data-ogb-slots]') || this.q('[data-ogb-box]'), pin = this.q('[data-ogb-pin]');
    if (!box || !pin || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      pin.classList.toggle('is-shown', !e.isIntersecting && e.boundingClientRect.top < 0 && window.innerWidth < 1000);
    }, { rootMargin: '0px' }).observe(box);
  };

  /* ===== Quick view popup ===== */
  P.initQV = function () {
    var self = this;
    this.qv = this.q('[data-ogb-qv-modal]');
    if (!this.qv) return;
    this.qvCache = {};
    this.qvOpen = false;
    this.qvPushed = false;
    document.addEventListener('keydown', function (e) {
      if (!self.qvOpen) return;
      if (e.key === 'Escape') { e.preventDefault(); self.closeQV(true); }
      else if (e.key === 'Tab') self.qvTrap(e);
    });
    /* phone back button or gesture closes the popup instead of leaving the page */
    window.addEventListener('popstate', function () { if (self.qvOpen) self.closeQV(false); });
  };

  P.qvTrap = function (e) {
    var f = Array.prototype.filter.call(
      this.qv.querySelectorAll('button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null; }
    );
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };

  P.openQV = function (card) {
    if (!this.qv) return;
    var self = this, m = this.qv, body = m.querySelector('[data-ogb-qv-body]'), panel = m.querySelector('[data-ogb-qv-panel]');
    this.qvCard = card;
    if (!this.qvOpen) this.qvReturn = document.activeElement;
    body.innerHTML = '<p class="ogb-qv__status">' + esc(this.d.qvLoading) + '</p>';
    if (panel) panel.scrollTop = 0;
    this.qvButton();

    if (!this.qvOpen) {
      m.hidden = false;
      void m.offsetWidth;
      m.classList.add('is-open');
      document.documentElement.classList.add('ogb-lock');
      this.qvOpen = true;
      if (!this.qvPushed && window.history && history.pushState) {
        try { history.pushState({ ogbQV: true }, ''); this.qvPushed = true; } catch (err) { this.qvPushed = false; }
      }
      var closeBtn = m.querySelector('[data-ogb-qv-close]');
      if (closeBtn) { try { closeBtn.focus({ preventScroll: true }); } catch (err) { closeBtn.focus(); } }
    }

    var url = card.dataset.jsUrl;
    var req = this.qvCache[url] ? Promise.resolve(this.qvCache[url]) :
      fetch(url, { headers: { 'Accept': 'application/json' } }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.json();
      });
    req.then(function (data) {
      self.qvCache[url] = data;
      if (self.qvOpen && self.qvCard === card) self.renderQV(card, data);
    }).catch(function () {
      if (self.qvOpen && self.qvCard === card) body.innerHTML = '<p class="ogb-qv__status">' + esc(self.d.qvError) + '</p>';
    });
  };

  P.renderQV = function (card, p) {
    var body = this.qv.querySelector('[data-ogb-qv-body]');
    var titleId = this.qv.getAttribute('data-title-id');
    var cd = card.dataset, descEl = card.querySelector('.ogb-desc');
    var srcs = [];
    (p.media || []).forEach(function (x) { if (x && x.media_type === 'image' && x.src) srcs.push(x.src); });
    if (!srcs.length) srcs = (p.images || []).slice();

    var html = '';
    if (srcs.length) {
      html += '<div class="ogb-qv__gallery"><div class="ogb-qv__track" data-ogb-qv-track>' +
        srcs.map(function (s, i) {
          return '<div class="ogb-qv__slide"><img src="' + esc(sizedImg(s, 900)) + '"' +
            ' srcset="' + esc(sizedImg(s, 500)) + ' 500w, ' + esc(sizedImg(s, 900)) + ' 900w, ' + esc(sizedImg(s, 1200)) + ' 1200w"' +
            ' sizes="(min-width: 768px) 460px, 100vw" alt="' + esc(p.title) + (srcs.length > 1 ? ', ' + (i + 1) : '') + '"' +
            (i ? ' loading="lazy"' : '') + ' width="900" height="900"></div>';
        }).join('') + '</div>';
      if (srcs.length > 1) {
        html += '<div class="ogb-qv__dots">' + srcs.map(function (s, i) {
          return '<button type="button" data-ogb-qv-dot="' + i + '" aria-label="Image ' + (i + 1) + '"' + (i ? '' : ' aria-current="true"') + '></button>';
        }).join('') + '</div>';
      }
      html += '</div>';
    }

    var price = parseInt(cd.price, 10) || 0;
    html += '<div class="ogb-qv__info">' +
      '<h2 class="ogb-qv__title" id="' + esc(titleId) + '">' + esc(p.title) + '</h2>' +
      (descEl && descEl.textContent.trim() ? '<p class="ogb-qv__short">' + esc(descEl.textContent.trim()) + '</p>' : '') +
      '<p class="ogb-qv__price">' + this.money(price) + (cd.variantTitle ? '<span>' + esc(cd.variantTitle) + '</span>' : '') + '</p>' +
      (p.description ? '<div class="ogb-qv__rte">' + p.description + '</div>' : '') +
      '</div>';
    body.innerHTML = html;

    /* keep customers on this page: links to product pages inside the description become plain text */
    each(body.querySelectorAll('.ogb-qv__rte a[href*="/products/"]'), function (a) {
      var span = document.createElement('span');
      span.textContent = a.textContent;
      a.parentNode.replaceChild(span, a);
    });

    var track = body.querySelector('[data-ogb-qv-track]');
    if (track) {
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        each(body.querySelectorAll('[data-ogb-qv-dot]'), function (dot, k) {
          if (k === i) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
        });
      }, { passive: true });
    }
  };

  P.qvGoTo = function (i) {
    var track = this.qv && this.qv.querySelector('[data-ogb-qv-track]');
    if (track) track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
  };

  P.qvButton = function () {
    var b = this.qv && this.qv.querySelector('[data-ogb-qv-add]'), card = this.qvCard;
    if (!b || !card) return;
    var d = this.d, c = this.count(card.dataset.id), full = this.filled() >= this.size;
    var sold = card.hasAttribute('data-soldout') || card.hasAttribute('data-unavailable');
    b.disabled = sold || full;
    b.textContent = sold ? d.soldOutLabel : (full ? (c ? d.inBoxLabel : d.fullLabel) : (c ? (d.qvAddAnother || d.addLabel) : d.addLabel));
  };

  P.qvAdd = function () {
    var self = this;
    if (!this.qvCard || !this.add(this.qvCard)) return;
    setTimeout(function () { self.closeQV(true); }, 350);
  };

  P.closeQV = function (fromUI) {
    if (!this.qvOpen) return;
    if (fromUI && this.qvPushed) {
      this.qvPushed = false;
      history.back(); /* popstate then finishes the close */
      return;
    }
    var self = this, m = this.qv;
    this.qvOpen = false;
    this.qvPushed = false;
    m.classList.remove('is-open');
    document.documentElement.classList.remove('ogb-lock');
    setTimeout(function () { if (!self.qvOpen) m.hidden = true; }, 320);
    if (this.qvReturn && this.qvReturn.focus) {
      try { this.qvReturn.focus({ preventScroll: true }); } catch (err) { this.qvReturn.focus(); }
    }
  };

  P.selectVariant = function (card, btn) {
    if (btn.disabled) return;
    var b = btn.dataset;
    card.dataset.variantId = b.variantId;
    card.dataset.variantTitle = b.variantTitle;
    card.dataset.price = b.price;
    card.dataset.compare = b.compare;
    each(card.querySelectorAll('[data-ogb-var]'), function (x) { x.setAttribute('aria-pressed', x === btn ? 'true' : 'false'); });
    this.render();
  };

  P.selectOptions = function (card) {
    if (!card.__variants) {
      var el = card.querySelector('[data-ogb-variants]');
      try { card.__variants = el ? JSON.parse(el.textContent) : []; } catch (err) { card.__variants = []; }
    }
    var picked = Array.prototype.map.call(card.querySelectorAll('[data-ogb-opt]'), function (s) {
      return { i: parseInt(s.getAttribute('data-ogb-opt'), 10), val: s.value };
    });
    var match = null;
    card.__variants.forEach(function (v) {
      if (!match && picked.every(function (p) { return v.options[p.i] === p.val; })) match = v;
    });
    if (match && match.available) {
      card.removeAttribute('data-unavailable');
      card.dataset.variantId = match.id;
      card.dataset.variantTitle = match.title;
      card.dataset.price = match.price;
      card.dataset.compare = match.compare || 0;
    } else {
      card.setAttribute('data-unavailable', '');
      if (match) { card.dataset.price = match.price; card.dataset.compare = match.compare || 0; }
    }
    this.render();
  };

  P.selectTab = function (tab) {
    var key = tab.getAttribute('data-ogb-tab');
    each(this.root.querySelectorAll('[data-ogb-tab]'), function (x) {
      var on = x === tab;
      x.setAttribute('aria-selected', on ? 'true' : 'false');
      x.setAttribute('tabindex', on ? '0' : '-1');
    });
    this.cards.forEach(function (c) {
      var cats = (c.dataset.cats || '').split(' ');
      c.hidden = !(key === 'all' || cats.indexOf(key) > -1);
    });
  };

  P.render = function () {
    var self = this, d = this.d, size = this.size;
    var n = this.filled(), full = n >= size, left = size - n;

    /* cards */
    this.cards.forEach(function (card) {
      var cd = card.dataset, c = self.count(cd.id), price = parseInt(cd.price, 10) || 0, cmp = parseInt(cd.compare, 10) || 0;
      card.classList.toggle('is-in', c > 0);
      var badge = card.querySelector('[data-ogb-badge]');
      if (badge) badge.textContent = c ? d.inBoxLabel + (c > 1 ? ', ' + c : '') : '';
      var pr = card.querySelector('[data-ogb-price]');
      if (pr) {
        pr.innerHTML = self.money(price) + (cmp > price ? '<s>' + self.money(cmp) + '</s>' : '');
        pr.classList.toggle('is-sale', cmp > price);
      }
      var act = card.querySelector('[data-ogb-act]');
      if (!act || card.hasAttribute('data-soldout')) return;
      if (card.hasAttribute('data-unavailable') && !c) {
        act.innerHTML = '<button type="button" class="ogb-add" disabled>' + esc(d.soldOutLabel) + '</button>';
        return;
      }
      var blocked = full || card.hasAttribute('data-unavailable');
      if (c) {
        act.innerHTML = '<div class="ogb-step"><button type="button" data-ogb-minus aria-label="Remove one ' + esc(cd.title) + '">&minus;</button><span>' + c + '</span><button type="button" data-ogb-plus aria-label="Add another ' + esc(cd.title) + '"' + (blocked ? ' disabled' : '') + '>+</button></div>';
      } else {
        act.innerHTML = '<button type="button" class="ogb-add" data-ogb-plus' + (full ? ' disabled' : '') + '>' + esc(full ? d.fullLabel : d.addLabel) + '</button>';
      }
    });

    /* presets */
    this.presets.forEach(function (p, i) { p.setAttribute('aria-pressed', i === self.activePreset ? 'true' : 'false'); });

    /* slots in the box */
    each(this.root.querySelectorAll('[data-ogb-slot]'), function (s, i) {
      var b = self.box[i], img = s.querySelector('img'), x = s.querySelector('[data-ogb-remove]');
      s.classList.toggle('is-filled', !!b);
      var isNew = b && (self.lastAdded === 'all' || self.lastAdded === i);
      s.classList.remove('is-new');
      if (b) {
        if (img.getAttribute('src') !== b.img) img.src = b.img;
        img.alt = b.title; img.hidden = !b.img;
        x.setAttribute('aria-label', 'Remove ' + b.title);
        if (isNew) { void s.offsetWidth; s.classList.add('is-new'); }
      } else {
        img.removeAttribute('src'); img.alt = ''; img.hidden = true;
      }
    });
    if (this.lastAdded !== -1) this.lastAdded = -1;

    /* pin bar slots */
    each(this.root.querySelectorAll('[data-ogb-pinslot]'), function (s, i) {
      var b = self.box[i];
      s.classList.toggle('is-filled', !!(b && b.img));
      s.innerHTML = b && b.img ? '<img src="' + esc(b.img) + '" alt="">' : String(i + 1);
    });

    /* names list */
    var names = this.q('[data-ogb-names]');
    if (names) {
      names.innerHTML = this.box.filter(Boolean).map(function (b) {
        return '<li>' + (b.img ? '<img src="' + esc(b.img) + '" alt="" width="38" height="38" loading="lazy">' : '') +
          '<span class="ogb-names__nm">' + esc(b.title) + (b.sub ? '<small>' + esc(b.sub) + '</small>' : '') + '</span>' +
          '<span class="ogb-names__pr">' + self.money(b.price) + '</span></li>';
      }).join('');
    }
    /* initials: only offered when an engravable piece is in the box */
    var engItems = this.box.filter(function (b) { return b && b.eng; });
    var iniWrap = this.q('[data-ogb-initials-wrap]');
    if (iniWrap) {
      iniWrap.hidden = engItems.length === 0;
      if (engItems.length === 0) {
        var t = this.q('[data-ogb-initials-tog]'), f = this.q('[data-ogb-initials]');
        if (t) t.checked = false;
        if (f) f.value = '';
        iniWrap.classList.remove('is-open');
      }
      var onBox = this.q('[data-ogb-initials-on]'), onSel = this.q('[data-ogb-initials-onsel]');
      if (onBox && onSel) {
        onBox.hidden = engItems.length < 2;
        if (engItems.length > 1) {
          var keep = onSel.value;
          onSel.innerHTML = engItems.map(function (b) { return '<option value="' + esc(b.title) + '">' + esc(b.title) + '</option>'; }).join('');
          if (keep) onSel.value = keep;
          if (!onSel.value) onSel.selectedIndex = 0;
        }
      }
    }
    /* counter, progress line, hint */
    var of = this.q('[data-ogb-of]'); if (of) of.textContent = n + ' ' + d.ofLabel + ' ' + size;
    var meter = this.q('[data-ogb-meter]'); if (meter) meter.style.width = (n / size * 100) + '%';
    var hint = this.q('[data-ogb-hint]');
    if (hint) hint.textContent = full ? this.fill(d.hintDone, left, size) : this.fill(n ? d.hintMore : d.hintStart, left, size);

    /* totals */
    var sub = this.box.reduce(function (t, b) { return t + (b ? b.price : 0); }, 0);
    var save = full ? Math.round(sub * this.pct / 100) : 0;
    var total = sub - save;
    var totals = this.q('[data-ogb-totals]');
    if (totals) {
      totals.innerHTML =
        '<div class="ogb-row ogb-row--muted"><span>' + esc(d.subtotalLabel) + '</span><span>' + this.money(sub) + '</span></div>' +
        (full && save > 0 ? '<div class="ogb-row ogb-row--save"><span>' + esc(d.saveLabel) + '</span><span>&minus;' + this.money(save) + '</span></div>' : '') +
        (n && d.includedLabel ? '<div class="ogb-row ogb-row--muted"><span>' + esc(d.includedLabel) + '</span><span>' + esc(d.includedValue) + '</span></div>' : '') +
        '<div class="ogb-row ogb-row--total"><span>' + esc(d.totalLabel) + '</span><span>' + (full && save > 0 ? '<s>' + this.money(sub) + '</s>' : '') + this.money(total) + '</span></div>';
    }

    /* CTAs */
    var deskTxt = full ? esc(d.ctaReady).replace('[total]', this.money(total)) : esc(this.fill(n ? d.ctaMore : d.ctaEmpty, left, size));
    var mobTxt = full ? esc(d.ctaReadyMobile) : esc(this.fill(n ? d.ctaMore : d.ctaEmpty, left, size));
    each(this.root.querySelectorAll('[data-ogb-cta]'), function (cta) {
      if (cta.classList.contains('is-busy')) return;
      cta.disabled = !full;
      cta.innerHTML = cta.hasAttribute('data-ogb-cta-mobile') ? mobTxt : deskTxt;
    });

    var bp = this.q('[data-ogb-barprice]');
    if (bp) bp.innerHTML = full ?
      esc(d.youSave) + ' ' + this.money(save) + '<b>' + this.money(total) + '</b>' :
      n + ' ' + esc(d.ofLabel) + ' ' + size + ' ' + esc(d.chosenLabel) + '<b>' + (n ? this.money(sub) : '&nbsp;') + '</b>';

    var pt = this.q('[data-ogb-pintext]');
    if (pt) pt.textContent = full ? d.completeLabel + ', ' + formatMoney(total, d.moneyFormat, d.hideZeros === 'true').replace(/<[^>]*>/g, '') : n + ' ' + d.ofLabel + ' ' + size + ' ' + d.chosenLabel;

    if (this.qvOpen) this.qvButton();

    this.root.classList.toggle('is-complete', full);
  };

  P.onCta = function (btn) {
    if (this.filled() !== this.size || btn.classList.contains('is-busy')) return;
    var note = this.q('[data-ogb-note]');
    if (btn.hasAttribute('data-ogb-cta-mobile') && this.d.notePrompt === 'true' && note && !note.open && !this.prompted) {
      this.prompted = true;
      note.open = true;
      this.q('[data-ogb-panel]').scrollIntoView({ behavior: 'smooth', block: 'end' });
      this.say(this.d.msgNote);
      return;
    }
    this.addToCart(btn);
  };

  P.addToCart = function (btn) {
    var self = this, d = this.d;
    var err = this.q('[data-ogb-error]');
    err.hidden = true;

    var boxId = 'GB-' + Date.now().toString(36).toUpperCase();
    var gift = {};
    var to = this.q('[data-ogb-to]'), from = this.q('[data-ogb-from]'), note = this.q('[data-ogb-notetext]'), off = this.q('[data-ogb-priceoff]');
    if (to && to.value.trim()) gift['To'] = to.value.trim();
    if (from && from.value.trim()) gift['From'] = from.value.trim();
    if (note && note.value.trim()) gift['Gift note'] = note.value.trim();
    if (off && off.checked) gift['Gift receipt'] = 'Prices left off';

    var iniTog = this.q('[data-ogb-initials-tog]'), ini = this.q('[data-ogb-initials]');
    if (iniTog && iniTog.checked) {
      var letters = ini ? ini.value.replace(/[^A-Za-z]/g, '').toUpperCase().slice(0, 2) : '';
      if (!letters) {
        err.textContent = d.initialsError || 'Add the initials, or untick the box.';
        err.hidden = false;
        if (ini) ini.focus();
        return;
      }
      gift[d.initialsProp || 'Initials'] = letters;
            var engList = this.box.filter(function (b) { return b && b.eng; });
      var onSel2 = this.q('[data-ogb-initials-onsel]');
      var onName = engList.length > 1 && onSel2 && onSel2.value ? onSel2.value : (engList[0] ? engList[0].title : '');
      if (onName && d.initialsOnProp) gift[d.initialsOnProp] = onName;
    }
    var wrap = this.q('[data-ogb-wrap]');
    if (wrap && wrap.checked) gift[d.wrapProp || 'Gift wrapping'] = d.wrapValue || 'Yes';
    var items = this.box.map(function (b, i) {
      var props = { '_Gift box': boxId };
      if (i === 0) for (var k in gift) props[k] = gift[k];
      return { id: parseInt(b.variantId, 10), quantity: 1, properties: props };
    });

    var ctas = this.root.querySelectorAll('[data-ogb-cta]');
    each(ctas, function (c) { c.classList.add('is-busy'); c.disabled = true; c.textContent = d.ctaBusy; });

    fetch(d.addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (j) { return r.ok ? j : Promise.reject(j); }); })
      .then(function () {
        for (var i = 0; i < self.box.length; i++) self.box[i] = null;
        self.activePreset = -1; self.prompted = false;
        [to, from, note].forEach(function (f) { if (f) f.value = ''; });
        var cnt = self.q('[data-ogb-count]'); if (cnt) cnt.textContent = '0';
        var nd = self.q('[data-ogb-note]'); if (nd) nd.open = false;
                [self.q('[data-ogb-initials-tog]'), self.q('[data-ogb-wrap]')].forEach(function (c) { if (c) c.checked = false; });
        if (self.q('[data-ogb-initials]')) self.q('[data-ogb-initials]').value = '';
        var iw = self.q('[data-ogb-initials-wrap]'); if (iw) iw.classList.remove('is-open');
        self.say('');

        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

        var opener = document.querySelector('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]');
        if (d.afterAdd === 'drawer' && opener) {
          each(ctas, function (c) { c.classList.remove('is-busy'); });
          self.render();
          setTimeout(function () { opener.click(); }, 150);
        } else {
          window.location.href = d.cartUrl;
        }
      })
      .catch(function (e) {
        each(ctas, function (c) { c.classList.remove('is-busy'); });
        err.textContent = (e && (e.description || e.message)) || 'Something went wrong. Please try again.';
        err.hidden = false;
        self.render();
      });
  };

  function setTopOffset() {
    var h = document.querySelector('#shopify-section-header, .shopify-section--header, [data-section-type="header"]');
    var off = 0;
    if (h) {
      var inner = h.querySelector('.Header') || h;
      if (/sticky|fixed/.test(getComputedStyle(h).position) || /sticky|fixed/.test(getComputedStyle(inner).position)) {
        off = Math.round(h.getBoundingClientRect().height);
      }
    }
    document.documentElement.style.setProperty('--ogb-top', off + 'px');
  }

  function init(scope) {
    setTopOffset();
    each((scope || document).querySelectorAll('[data-ogb]'), function (el) {
      if (el.__ogb) return;
      el.__ogb = new Builder(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.addEventListener('resize', setTopOffset);
})();